<script>
export default {
  name: 'MoneyFormat',
  methods: {
    formatAmount(amount) {
      if (amount) {
        return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      }
      return amount;
    },
    formatAmountWithFraction(value, fractionDigits = 1) {
      const amount = Math.abs(Number(value));
      const result = amount.toLocaleString(undefined, { maximumFractionDigits: fractionDigits, minimumFractionDigits: fractionDigits });
      return result.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
  },
};
</script>
